import React from 'react';

/* The one stats pattern used sitewide — big number + short label. Type lives
   in index.css (.stat-value / .stat-label), so changing it there changes
   every page: solution pages, case studies, Rapid Prototyping, the About
   block. Use these components instead of re-creating the markup. */

export const StatItem = ({ value, label, color, size }) => (
  <div>
    <p className="stat-value" style={{ color, ...(size ? { '--stat-size': size } : null) }}>{value}</p>
    <p className="stat-label mt-2 md:mt-3">{label}</p>
  </div>
);

/* Full-width strip that sits directly under a hero. Three items stay in one
   row; four split 2×2 on phones. */
export const StatsStrip = ({ items, color }) => (
  <section className="relative w-full py-16 md:py-20 bg-bg-color border-b border-border-color">
    <div className={`w-full px-[8vw] grid ${items.length === 4 ? 'grid-cols-2 md:grid-cols-4 gap-y-10' : 'grid-cols-3'} gap-x-6 md:gap-x-16 text-center`}>
      {items.map((item) => (
        <StatItem key={item.label} value={item.value} label={item.label} color={color} />
      ))}
    </div>
  </section>
);
